import { useEffect, useRef } from 'react';

export function useFIFOEffect(effectFn: () => Promise<void>, deps: any[]) {
  const queueRef = useRef<(() => Promise<void>)[]>([]);
  const runningRef = useRef(false);

  async function runQueue() {
    if (runningRef.current) return;
    runningRef.current = true;

    while (queueRef.current.length > 0) {
      const fn = queueRef.current.shift();
      if (fn) {
        try {
          await fn();
        } catch (err) {
          console.error('Error in queued function:', err);
        }
      }
    }

    runningRef.current = false;
  }

  useEffect(() => {
    queueRef.current.push(effectFn);
    runQueue();
  }, deps); // only runs when dependencies change
}
